import script from "./CommLogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommLogModal.vue?vue&type=script&setup=true&lang=js"

import "./CommLogModal.vue?vue&type=style&index=0&id=1aee6ec7&scoped=true&lang=css"

import exportComponent from "/var/www/html/a4m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aee6ec7"]])

export default __exports__